




















































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api';
import { gmapApi } from 'vue2-google-maps';

import DeliveryOnMap from '@/components/Overall/DeliveryOnMap.vue';
import useAuth from '@/useAuth';

const DeliveryMap = defineComponent({
  components: {
    DeliveryOnMap,
  },
  props: {
    markers: {},
    ids: { default: () => ([]) },
    cars: { default: () => ({}) },
    carStamps: { default: () => [] },
    width: { default: '830px' },
    height: { default: '830px' },
    drawVehicleDirection: { default: false },
    drawDeliveryDirection: { default: false },
    showDeliveryNumber: { default: false },
    showVehicleLicense: { default: false },
    showOrderNumber: { default: true },
  },
  setup(props: any, { emit }) {
    const { me } = useAuth();
    const center = computed(() => {
      if (me.hub && me.hub?.lat !== 0 && me.hub?.long !== 0) return { lat: me.hub?.lat || 13.6878603, lng: me.hub?.long || 100.525023 };
      return { lat: 13.6878603, lng: 100.525023 };
    });

    const map = ref(null);
    const activeMarkerIndex = ref(-1);
    const google = computed(() => gmapApi());
    const mapStyle = {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false,
      styles: [
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit.line',
          elementType: 'labels.text.stroke',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit.line',
          elementType: 'labels.text.fill',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }],
        },
        // {
        //   featureType: 'poi.business',
        //   stylers: [{ visibility: 'off' }],
        // },
        // {
        //   featureType: 'poi.place_of_worship',
        //   stylers: [{ visibility: 'off' }],
        // },
        // {
        //   featureType: 'landscape',
        //   stylers: [{ visibility: 'off' }],
        // },
      ],
    };

    const colorIndex = ref(0);
    const COLORS = ['#fc77f8', '#0ccf2d', '#0cc8cf', '#e0ce00', '#b31515', '#e87800', '#21ffb5', '#de00b9', '#8300ab', '#000ead', '#ad4800', '#fff700', '#8cff00'];
    function getColor() {
      if (colorIndex.value === 9) colorIndex.value = 0;
      else colorIndex.value += 1;
      return COLORS[colorIndex.value];
    }

    function getDeliveryMarkerImage(index: number, status: string) {
      if (status === 'SUCCESS') return `/img/icons/google-map-custom-pin/finish/PINNumber${index + 1 < 10 ? '0' : ''}${index + 1}-finish.svg`;
      if (status === 'NOT_SUCCESS') return `/img/icons/google-map-custom-pin/fail/PINNumber${index + 1 < 10 ? '0' : ''}${index + 1}-fail.svg`;
      return `/img/icons/google-map-custom-pin/normal/PINNumber${index + 1 < 10 ? '0' : ''}${index + 1}-normal.svg`;
    }

    const getDottedDirection = (color: string) => ({
      strokeColor: color,
      strokeOpacity: 0,
      icons: [{
        icon: {
          path: google.value.maps.SymbolPath.CIRCLE,
          fillOpacity: 1,
          scale: 3,
        },
        offset: '0',
        repeat: '10px',
      }],
    });
    const getStraightDirection = (color: string) => ({
      strokeColor: color,
      strokeOpacity: 1,
      strokeWeight: 5,
    });

    function getDirection(markerArray: any[], index: number, dot = false) {
      /* eslint-disable */
      const color = getColor();
      const directionsService = new google.value.maps.DirectionsService;
      const directionsRenderer = new google.value.maps.DirectionsRenderer({
        polylineOptions: dot ? getDottedDirection(color) : getStraightDirection(color),
        suppressMarkers: true,
      });
      directionsRenderer.setMap((map.value as any).$mapObject);

      const waypoints: { location: { lat: number; lng: number}; stopover?: boolean }[] = [];
      markerArray.forEach((marker: any) => {
        if (marker.lat !== 0 && marker.lng !== 0) {
          waypoints.push({
            location: {
              lat: marker.lat, lng: marker.lng,
            },
            stopover: false,
          });
        }
      });

      // google maps API's direction service
      function calculateAndDisplayRoute(directionsService2: any, directionsDisplay1: any) {
        directionsService2.route({
          origin: center.value,
          destination: waypoints[waypoints.length - 1]?.location,
          waypoints,
          travelMode: 'DRIVING',
        }, (response: any, status: any) => {
          if (status === 'OK') {
            directionsDisplay1.setDirections(response);
          } else {
            console.error(`Directions request failed due to ${status}`);
          }
        });
      }

      if (waypoints.length > 0) calculateAndDisplayRoute(directionsService, directionsRenderer);
      if (props.ids.length > 0) emit('updateRoute', { id: props.ids[index], color });
    }

    const mapReady = ref(false);
    const markersReady = ref(false);
    const readyToRender = computed(() => mapReady.value && markersReady.value && !(props.refetch));
    watch(() => google.value, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal && map.value) {
        mapReady.value = true;
      }
    });
    watch(() => props.markers.length, (newVal, oldVal) => {
      if (newVal > 0 && newVal !== oldVal) {
        markersReady.value = true;
      }
    });
    watch(() => readyToRender.value, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal && props.drawDeliveryDirection) {
        for (let i = 0; i < props.markers.length; i += 1) {
          getDirection(props.markers[i], i, false);
        }
      }
    });

    function rerender() {
      if (props.drawDeliveryDirection) {
        for (let i = 0; i < props.markers.length; i += 1) {
          getDirection(props.markers[i], i, false);
        }
      }
    }

    return {
      map,
      center,
      mapStyle,
      activeMarkerIndex,
      google,

      rerender,

      getDeliveryMarkerImage,
    };
  },
});

export default DeliveryMap;
